import apiService from './api.service';

/** Company presets for new sales quotations and the print cover letter (stored as HTML from FormattedTextArea). */
export interface QuotationDefaults {
  payment_terms: string;
  delivery_terms: string;
  notes: string;
  terms_and_conditions: string;
  special_instructions: string;
  validity_days: number | null;
  print_salutation: string;
  print_intro: string;
  print_intro_rental: string;
}

export interface QuotationDefaultsResponse extends QuotationDefaults {
  built_in: { print_salutation: string; print_intro: string; print_intro_rental: string };
}

const BASE = '/crm/quotation-defaults';

export const quotationDefaultsService = {
  async get(): Promise<QuotationDefaultsResponse> {
    const res = await apiService.get<QuotationDefaultsResponse>(BASE);
    return res.data as QuotationDefaultsResponse;
  },

  async update(payload: Partial<QuotationDefaults>): Promise<QuotationDefaultsResponse> {
    const res = await apiService.put<QuotationDefaultsResponse>(BASE, payload);
    return res.data as QuotationDefaultsResponse;
  },
};

export default quotationDefaultsService;
